'use strict';

module.exports = function block(state) {

  if (state.inlineMode) {
    state.tokens.push({
      type: 'inline',
      content: state.src.replace(/\n/g, ' ').trim(),
      level: 0,
      lines: [ 0, 1 ],
      children: []
    });

  } else {
    state.block.parse(state.src, state.options, state.env, state.tokens);
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/remarkable/lib/rules_core/block.js
 ** module id = 998
 ** module chunks = 1
 **/